// extracted by css-extract-rspack-plugin
export default {"cls1":"ActionNav-cls1_4Zx","cls2":"ActionNav-cls2_kYd ActionNav-cls1_4Zx"};